// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';
import LRU from 'lru-cache';

const cache = LRU({ max: 5, maxAge: 1000 * 60 * 5 }); // 5 mins max age

type Props = {
  clientId: Id,
  channelName: string,
  endDateTime?: string,
};
const getChannelContent = wrapWithNetworkError(function getChannelContent(
  token: string,
  { clientId, channelName, endDateTime }: Props
) {
  const queryString = endDateTime ? `?end_date_time=${endDateTime}` : '';
  const fetchUrl = getEndpointUrl(
    `/moderate/content/client/${clientId}/channel/${channelName}${queryString}`
  );
  const fetchOptions = {
    headers: {
      Authorization: token,
    },
  };

  if (cache.has(fetchUrl)) {
    const data = cache.get(fetchUrl);
    if (data) {
      // this probably shouldn't be here
      // we introduce a delay so the spinner shows up and the page
      // looks less jerky
      return new Promise(resolve => setTimeout(resolve, 10, data));
      // return Promise.resolve(data);
    }
  }

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => {
      if (response.status === 204) {
        return [];
      }

      return response.json();
    })
    .then((json: GetContentResponse) => (Array.isArray(json) ? json : [json]))
    .then(response => {
      cache.set(fetchUrl, response);
      return response;
    });
});

export default getChannelContent;



// WEBPACK FOOTER //
// ./src/api/content/getChannelContent.js